<template>
  <div class="credit-info-page">
    <table class="credit-info-table user-info" style="">
      <tr>
        <td class="bc bold label">会员账号</td>
        <td class="left">{{ userInfo.username }}</td>
        <td class="bc bold label">状态</td>
        <td class="left">{{ userInfo.status | statusFormate }}</td>
        <td class="bc bold label">信用额度</td>
        <td class="left" style="width: 120px">{{ userInfo.credits }}</td>
        <td class="bc bold label">可用额度</td>
        <td class="left">{{ userInfo.balance }}</td>
        <!-- <td class="change-password">
          <input type="button" class="default_btn" value="修改密码" @click="changePassword()">
        </td> -->
      </tr>
    </table>
    <div class="title">赔率设置</div>
    <div class="credit-info-table credit">
      <table cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th>项目类型</th>
            <th>单注最低</th>
            <th>单注最高</th>
            <th>单项最高</th>
            <th>赔率上限</th>
            <th>赚水</th>
            <th>赔率</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="bc active-text label">一字定</td>
            <td colspan="6"></td>
          </tr>
          <tr
            sort="1"
            v-for="(item, index) in firstBallList"
            :key="item.sonProject"
          >
            <td class="bc label">第{{ index + 1 }}球</td>
            <td>{{ item.singleMin }}</td>
            <td>{{ item.singleMax }}</td>
            <td>{{ item.projectMax }}</td>
            <td>{{ item.peilvMax }}</td>
            <td>
              <select
                data-id="s_huishui"
                @change="changezs(item, 1)"
                v-model="item.zs"
              >
                <option
                  :value="zs"
                  v-for="(zs, zsIndex) in zuanshuiList"
                  :key="zsIndex"
                >
                  {{ zs }}
                </option>
              </select>
            </td>
            <td>
              <select
                data-id="s_odds"
                @change="changepl(item, 1)"
                v-model="item.peilv"
              >
                <option
                  v-for="(peilv, peilvindex) in index == 0
                    ? odds0
                    : index == 1
                    ? odds1
                    : index == 2
                    ? odds2
                    : index == 3
                    ? odds3
                    : odds4"
                  :key="peilvindex"
                  :value="peilv"
                >
                  {{ peilv }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="bc active-text label">二字定</td>
            <td colspan="6"></td>
          </tr>
          <tr v-for="(item, index) in secondBallList" :key="item.sonProject">
            <td class="bc labe">{{ item.sonProject }}</td>
            <td>{{ item.singleMin }}</td>
            <td>{{ item.singleMax }}</td>
            <td>{{ item.projectMax }}</td>
            <td>{{ item.peilvMax }}</td>
            <td>
              <select
                data-id="s_huishui"
                @change="changezs(item, 2)"
                v-model="item.zs"
              >
                <option
                  :value="zs"
                  v-for="(zs, zsIndex) in zuanshuiList"
                  :key="zsIndex"
                >
                  {{ zs }}
                </option>
              </select>
            </td>
            <td>
              <select
                data-id="s_odds"
                @change="changepl(item, 2)"
                v-model="item.peilv"
              >
                <option
                  v-for="(peilv, peilvindex) in index == 0
                    ? odds5
                    : index == 1
                    ? odds6
                    : index == 2
                    ? odds7
                    : index == 3
                    ? odds8
                    : index == 4
                    ? odds9
                    : index == 5
                    ? odds10
                    : index == 6
                    ? odds11
                    : index == 7
                    ? odds12
                    : index == 8
                    ? odds13
                    : odds14"
                  :key="peilvindex"
                  :value="peilv"
                >
                  {{ peilv }}
                </option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
      <table cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th>项目类型</th>
            <th>单注最低</th>
            <th>单注最高</th>
            <th>单项最高</th>
            <th>赔率上限</th>
            <th>赚水</th>
            <th>赔率</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="bc active-text label">三字定</td>
            <td colspan="6"></td>
          </tr>
          <tr v-for="(item, index) in thirdBallList" :key="item.sonProject">
            <td class="bc label">{{ item.sonProject }}</td>
            <td>{{ item.singleMin }}</td>
            <td>{{ item.singleMax }}</td>
            <td>{{ item.projectMax }}</td>
            <td>{{ item.peilvMax }}</td>
            <td>
              <select
                data-id="s_huishui"
                @change="changezs(item, 3)"
                v-model="item.zs"
              >
                <option
                  :value="zs"
                  v-for="(zs, zsIndex) in zuanshuiList"
                  :key="zsIndex"
                >
                  {{ zs }}
                </option>
              </select>
            </td>
            <td>
              <select
                data-id="s_odds"
                @change="changepl(item, 3)"
                v-model="item.peilv"
              >
                <option
                  v-for="(peilv, peilvindex) in index == 0
                    ? odds15
                    : index == 1
                    ? odds16
                    : index == 2
                    ? odds17
                    : index == 3
                    ? odds18
                    : index == 4
                    ? odds19
                    : index == 5
                    ? odds20
                    : index == 6
                    ? odds21
                    : index == 7
                    ? odds22
                    : index == 8
                    ? odds23
                    : odds24"
                  :key="peilvindex"
                  :value="peilv"
                >
                  {{ peilv }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="bc active-text label">四字定</td>
            <td colspan="6"></td>
          </tr>
          <tr v-for="(item, index) in fourthBallList" :key="item.sonProject">
            <td class="bc labe">{{ item.sonProject }}</td>
            <td>{{ item.singleMin }}</td>
            <td>{{ item.singleMax }}</td>
            <td>{{ item.projectMax }}</td>
            <td>{{ item.peilvMax }}</td>
            <td>
              <select
                data-id="s_huishui"
                @change="changezs(item, 4)"
                v-model="item.zs"
              >
                <option
                  :value="zs"
                  v-for="(zs, zsIndex) in zuanshuiList"
                  :key="zsIndex"
                >
                  {{ zs }}
                </option>
              </select>
            </td>
            <td>
              <select
                data-id="s_odds"
                @change="changepl(item, 4)"
                v-model="item.peilv"
              >
                <option
                  v-for="(peilv, peilvindex) in index == 0
                    ? odds25
                    : index == 1
                    ? odds26
                    : index == 2
                    ? odds27
                    : index == 3
                    ? odds28
                    : odds29"
                  :key="peilvindex"
                  :value="peilv"
                >
                  {{ peilv }}
                </option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="bottom-btn">
      <input
        type="button"
        class="save btn primary"
        value="保存设置"
        @click="save()"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {
        username: "",
        balance: "",
        credits: "",
        status: "",
      },
      firstBallList: [],
      secondBallList: [],
      thirdBallList: [],
      fourthBallList: [],
    };
  },
  props: ["initFinished"],
  mounted() {
    this.initData();
  },
  watch: {
    initFinished() {
      this.initData();
    },
  },
  filters: {
    statusFormate(value) {
      let str = "";
      if (value == 1) {
        str = "启用";
      } else {
        str = "封禁";
      }
      return str;
    },
  },
  computed: {
    zuanshuiList() {
      let arr = [];
      for (let i = 0; i <= 200; i++) {
        arr.push(i / 1000);
      }
      return arr;
    },
    odds0() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.firstBallList[0].peilvMax * 1,
          i * 1 * Math.pow(10, 1)
        );
        arr.push((peilv * 1).toFixed(2) * 1);
      }
      return arr;
    },
    odds1() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.firstBallList[1].peilvMax * 1,
          i * 1 * Math.pow(10, 1)
        );
        arr.push((peilv * 1).toFixed(2) * 1 + "");
      }
      return arr;
    },
    odds2() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.firstBallList[2].peilvMax * 1,
          i * 1 * Math.pow(10, 1)
        );
        arr.push((peilv * 1).toFixed(2) * 1 + "");
      }
      return arr;
    },
    odds3() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.firstBallList[3].peilvMax * 1,
          i * 1 * Math.pow(10, 1)
        );
        arr.push((peilv * 1).toFixed(2) * 1 + "");
      }
      return arr;
    },
    odds4() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.firstBallList[4].peilvMax * 1,
          i * 1 * Math.pow(10, 1)
        );
        arr.push((peilv * 1).toFixed(2) * 1 + "");
      }
      return arr;
    },
    odds5() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.secondBallList[0].peilvMax * 1,
          i * 1 * Math.pow(10, 2)
        );
        arr.push((peilv * 1).toFixed(1) * 1 + "");
      }
      return arr;
    },
    odds6() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.secondBallList[1].peilvMax * 1,
          i * 1 * Math.pow(10, 2)
        );
        arr.push((peilv * 1).toFixed(1) * 1 + "");
      }
      return arr;
    },
    odds7() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.secondBallList[2].peilvMax * 1,
          i * 1 * Math.pow(10, 2)
        );
        arr.push((peilv * 1).toFixed(1) * 1 + "");
      }
      return arr;
    },
    odds8() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.secondBallList[3].peilvMax * 1,
          i * 1 * Math.pow(10, 2)
        );
        arr.push((peilv * 1).toFixed(1) * 1 + "");
      }
      return arr;
    },
    odds9() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.secondBallList[4].peilvMax * 1,
          i * 1 * Math.pow(10, 2)
        );
        arr.push((peilv * 1).toFixed(1) * 1 + "");
      }
      return arr;
    },
    odds10() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.secondBallList[5].peilvMax * 1,
          i * 1 * Math.pow(10, 2)
        );
        arr.push((peilv * 1).toFixed(1) * 1 + "");
      }
      return arr;
    },
    odds11() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.secondBallList[6].peilvMax * 1,
          i * 1 * Math.pow(10, 2)
        );
        arr.push((peilv * 1).toFixed(1) * 1 + "");
      }
      return arr;
    },
    odds12() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.secondBallList[7].peilvMax * 1,
          i * 1 * Math.pow(10, 2)
        );
        arr.push((peilv * 1).toFixed(1) * 1 + "");
      }
      return arr;
    },
    odds13() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.secondBallList[8].peilvMax * 1,
          i * 1 * Math.pow(10, 2)
        );
        arr.push((peilv * 1).toFixed(1) * 1 + "");
      }
      return arr;
    },
    odds14() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.secondBallList[9].peilvMax * 1,
          i * 1 * Math.pow(10, 2)
        );
        arr.push((peilv * 1).toFixed(1) * 1 + "");
      }
      return arr;
    },
    odds15() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.thirdBallList[0].peilvMax * 1,
          i * 1 * Math.pow(10, 3)
        );
        arr.push((peilv * 1).toFixed(0) * 1 + "");
      }
      return arr;
    },
    odds16() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.thirdBallList[1].peilvMax * 1,
          i * 1 * Math.pow(10, 3)
        );
        arr.push((peilv * 1).toFixed(0) * 1 + "");
      }
      return arr;
    },
    odds17() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.thirdBallList[2].peilvMax * 1,
          i * 1 * Math.pow(10, 3)
        );
        arr.push((peilv * 1).toFixed(0) * 1 + "");
      }
      return arr;
    },
    odds18() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.thirdBallList[3].peilvMax * 1,
          i * 1 * Math.pow(10, 3)
        );
        arr.push((peilv * 1).toFixed(0) * 1 + "");
      }
      return arr;
    },
    odds19() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.thirdBallList[4].peilvMax * 1,
          i * 1 * Math.pow(10, 3)
        );
        arr.push((peilv * 1).toFixed(0) * 1 + "");
      }
      return arr;
    },
    odds20() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.thirdBallList[5].peilvMax * 1,
          i * 1 * Math.pow(10, 3)
        );
        arr.push((peilv * 1).toFixed(0) * 1 + "");
      }
      return arr;
    },
    odds21() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.thirdBallList[6].peilvMax * 1,
          i * 1 * Math.pow(10, 3)
        );
        arr.push((peilv * 1).toFixed(0) * 1 + "");
      }
      return arr;
    },
    odds22() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.thirdBallList[7].peilvMax * 1,
          i * 1 * Math.pow(10, 3)
        );
        arr.push((peilv * 1).toFixed(0) * 1 + "");
      }
      return arr;
    },
    odds23() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.thirdBallList[8].peilvMax * 1,
          i * 1 * Math.pow(10, 3)
        );
        arr.push((peilv * 1).toFixed(0) * 1 + "");
      }
      return arr;
    },
    odds24() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.thirdBallList[9].peilvMax * 1,
          i * 1 * Math.pow(10, 3)
        );
        arr.push((peilv * 1).toFixed(0) * 1 + "");
      }
      return arr;
    },
    odds25() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.fourthBallList[0].peilvMax * 1,
          i * 1 * Math.pow(10, 4)
        );
        arr.push((peilv / 10).toFixed(0) * 10 + "");
      }
      return arr;
    },
    odds26() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.fourthBallList[1].peilvMax * 1,
          i * 1 * Math.pow(10, 4)
        );
        arr.push((peilv / 10).toFixed(0) * 10 + "");
      }
      return arr;
    },
    odds27() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.fourthBallList[2].peilvMax * 1,
          i * 1 * Math.pow(10, 4)
        );
        arr.push((peilv / 10).toFixed(0) * 10 + "");
      }
      return arr;
    },
    odds28() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.fourthBallList[3].peilvMax * 1,
          i * 1 * Math.pow(10, 4)
        );
        arr.push((peilv / 10).toFixed(0) * 10 + "");
      }
      return arr;
    },
    odds29() {
      let arr = [];
      for (let i of this.zuanshuiList) {
        let peilv = this.$accSub(
          this.fourthBallList[4].peilvMax * 1,
          i * 1 * Math.pow(10, 4)
        );
        arr.push((peilv / 10).toFixed(0) * 10 + "");
      }
      return arr;
    },
  },
  methods: {
    initData() {
      if (this.initFinished) {
        this.getUserInfo();
      }
    },
    changePassword() {
      this.$emit("changePassword");
    },
    changezs(item, multiple) {
      let peilv = (
        this.$accSub(item.peilvMax * 1, item.zs * 1 * Math.pow(10, multiple)) *
        1
      ).toString();
      item.peilv = peilv;
      if (item.sonProject === "口XXXX") {
        this.firstBallList.forEach((ele) => {
          ele.zs = item.zs;
          ele.peilv = peilv;
        });
      } else if (item.sonProject === "口口XX") {
        this.secondBallList.forEach((ele) => {
          ele.zs = item.zs;
          ele.peilv = peilv;
        });
      } else if (item.sonProject === "口口口X") {
        this.thirdBallList.forEach((ele) => {
          ele.zs = item.zs;
          ele.peilv = peilv;
        });
      } else if (item.sonProject === "口口口口") {
        this.fourthBallList.forEach((ele) => {
          ele.zs = item.zs;
          ele.peilv = peilv;
        });
      }
    },
    changepl(item, multiple) {
      let zs = (
        this.$accDiv(
          this.$accSub(item.peilvMax * 1, item.peilv * 1),
          Math.pow(10, multiple)
        ).toFixed(3) * 1
      ).toString();
      item.zs = zs;
      if (item.sonProject === "口XXXX") {
        this.firstBallList.forEach((ele) => {
          ele.zs = zs;
          ele.peilv = item.peilv;
        });
      } else if (item.sonProject === "口口XX") {
        this.secondBallList.forEach((ele) => {
          ele.zs = zs;
          ele.peilv = item.peilv;
        });
      } else if (item.sonProject === "口口口X") {
        this.thirdBallList.forEach((ele) => {
          ele.zs = zs;
          ele.peilv = item.peilv;
        });
      } else if (item.sonProject === "口口口口") {
        this.fourthBallList.forEach((ele) => {
          ele.zs = zs;
          ele.peilv = item.peilv;
        });
      }
    },
    async getUserInfo() {
      let data = {
        access_token: this.$store.state.userInfo.access_token,
        uid: this.$store.state.userInfo.uid,
        code: this.$store.state.gameInfo[0].code,
      };
      let result = await this.$http.postAxiosMethod("/user/creditsinfo", data);
      if (result.code == 0) {
        this.userInfo.username = result.data.username;
        this.userInfo.balance = result.data.balance;
        this.userInfo.credits = result.data.credits;
        this.userInfo.status = result.data.status;
        result.data.odds.forEach((item) => {
          item.zs = item.back * 1 + "";
          item.peilv = item.peilv * 1 + "";
        });
        this.firstBallList = result.data.odds.filter(
          (item) => item.playName === "一字定"
        );
        this.secondBallList = result.data.odds.filter(
          (item) => item.playName === "二字定"
        );
        this.thirdBallList = result.data.odds.filter(
          (item) => item.playName === "三字定"
        );
        this.fourthBallList = result.data.odds.filter(
          (item) => item.playName === "四字定"
        );
      }
    },
    async save() {
      let oddsArr = [];
      this.firstBallList.forEach((item) => {
        oddsArr.push(`${item.playCode}:${item.sonProject}:${item.zs}`);
      });
      this.secondBallList.forEach((item) => {
        oddsArr.push(`${item.playCode}:${item.sonProject}:${item.zs}`);
      });
      this.thirdBallList.forEach((item) => {
        oddsArr.push(`${item.playCode}:${item.sonProject}:${item.zs}`);
      });
      this.fourthBallList.forEach((item) => {
        oddsArr.push(`${item.playCode}:${item.sonProject}:${item.zs}`);
      });
      let data = {
        access_token: this.$store.state.userInfo.access_token,
        uid: this.$store.state.userInfo.uid,
        code: this.$store.state.gameInfo[0].code,
        odds: oddsArr.join(","),
      };
      let result = await this.$http.postAxiosMethod("/user/editodds", data);
      if (result.code == 0) {
        this.$message({
          message: "保存成功",
          type: "success",
        });
      }
    },
    exit() {
      this.$emit("exit");
    },
  },
};
</script>

<style lang="scss" scoped>
.credit-info-page {
  background: var(--new-bg-white);
  overflow: hidden;
  .active-text {
    font-weight: bold;
  }
  .bold {
    font-weight: bold;
    color: #401e1e;
  }
  .left {
    text-align: left;
  }
  .bc {
    background: var(--new-bg-table-header-second);
  }
  > .title {
    padding: 0 24px;
    height: 35px;
    line-height: 35px;
    border: 1px solid var(--new-border);
    color: var(--new-text-primary-bg);
    background: var(--new-bg-primary);
  }
  .change-password {
    width: 120px;
    input[type="button"] {
      width: 89px;
      height: 25px;
      background: linear-gradient(90deg, #54aff3, #2992e1, #1082d7);
      border-radius: 2px;
      color: var(--new-text-primary-bg);
    }
  }
  .label {
    width: 90px;
    white-space: nowrap;
  }
  .credit-info-table {
    text-align: center;
    font-size: 14px;
    width: 100%;
    &.user-info {
      height: 50px;
      td {
        height: 50px;
        line-height: 50px;
      }
    }
    &.credit {
      display: flex;
      justify-content: space-between;
      table {
        width: 100%;
        font-size: 13px;
        border: 1px solid var(--new-border);
        border-right: none;
        border-bottom: none;
        &:not(:last-child) {
          // margin-right: 15px;
        }
        tr {
          border: 1px solid var(--new-border);
        }
        th,
        td {
          height: 30px;
          line-height: 30px;
          text-align: center;
          // &:not(:last-child) {
          border-right: 1px solid var(--new-border);
          border-bottom: 1px solid var(--new-border);
          // }
        }
        td {
          &::first-child {
            background: var(--new-bg-table-header-second);
          }
        }
        &.report-detail {
        }
        thead {
          background: var(--new-bg-table-header-main);
        }
        th {
          font-weight: bold;
        }
        tr:not(.sum) {
          cursor: pointer;
        }
      }
    }
  }
  .bottom-btn {
    position: relative;
    margin: 12px 0;
    text-align: center;
    input[type="button"] {
      width: unset;
      // padding: 0 10px;
      // width: 89px;
      // height: 25px;
      // background: linear-gradient(90deg, #54aff3, #2992e1, #1082d7);
      // border-radius: 2px;
      // color: #fff;
    }
  }
}
</style>
